@if (options.control) {
  <!-- add class "paste__icon" to see the new input -->
  <div
    class="relative text__input"
    [ngClass]="{ 'paste__icon reverse__input-icon': options.isAllowPaste }"
  >
    <input
      [type]="options.type"
      [id]="id"
      class="global-input peer"
      [placeholder]="options.label | translate | async"
      [formControl]="options.control"
      [ngClass]="{ invalid: options.control.invalid && options.isShowErrors }"
    />

    <label
      [for]="id"
      class="floating-label"
      [translate]="options.label"
      [ngClass]="{ required: isRequired }"
    >
      {{ options.label | translate | async }}
    </label>
    @if (options.isAllowPaste) {
      <div
        class="copy__icon"
        inlineSVG="inputs/paste.svg"
        (click)="paste()"
      ></div>
    }
  </div>
  <!-- <span class="text-red-500">Field Is Required</span> -->
} @else {
  Form Control Is Not Defined
}
@if (options.isShowErrors) {
  <span
    class="text-red-500 block"
    *ngIf="options.control?.errors?.['required']"
    translate="This field is required"
  ></span>
  <span
    class="text-red-500 block"
    *ngIf="
      options.control?.errors?.['email'] &&
      !options.control?.errors?.['required']
    "
    translate="Invalid Email"
  ></span>
  <span
    class="text-red-500 block"
    *ngIf="
      options.control?.errors?.['invalidEmail'] &&
      !options.control?.errors?.['required']
    "
    translate="Invalid Email"
  ></span>

  <span
    class="text-red-500 block"
    *ngIf="options.control?.errors?.['maxlength']"
    >{{ "The maximum number of characters is" | translate | async }}
    {{ options.control?.errors?.["maxlength"]?.requiredLength }}</span
  >
  <span
    class="text-red-500 block"
    *ngIf="options.control?.errors?.['minlength']"
    >{{ "The minimum number of characters is" | translate | async }}
    {{ options.control?.errors?.["minlength"]?.requiredLength }}</span
  >
  <span
    class="text-red-500 block"
    *ngIf="options.control?.errors?.['url']"
    translate="Invalid URL"
  >
  </span>

  <span
    class="text-red-500 block"
    *ngIf="options.control?.errors?.['whatsappPhoneNumber']"
    translate="Invalid WhatsApp Phone Number"
  ></span>

  <span
    class="text-red-500 block"
    *ngIf="options.control?.errors?.['phoneNumber']"
    translate="Invalid Phone Number"
  ></span>
}
